import BreadCrumb from '@medical/components/Breadcrumb'
import { FieldArray, Formik } from 'formik'
import Papa from 'papaparse'
import { Button } from 'primereact/button'
import React from 'react'
import Dropzone from 'react-dropzone'
import Router from '@medical/routes/router'
import * as Yup from 'yup'

const DocTorConsultationCsvScene = ({
  popup,
  i18n,
  onSubmit,
  downloadSample,
  isUploaded,
  checkCsvData,
  isUploadPermitted,
  isUploadCheckPermitted,
}) => {
  const translateKeys = {
    医師ナンバー: i18n.t('main.downloadDoctorConsultationTime.doctorNo'),
    年: i18n.t('main.downloadDoctorConsultationTime.year'),
    月: i18n.t('main.downloadDoctorConsultationTime.month'),
    平均診療時間: i18n.t('main.downloadDoctorConsultationTime.score'),
  }
  const validationSchema = Yup.object().shape({
    data: Yup.array()
      .min(1, '値をアップロードしてください')
      .of(
        Yup.object().shape({
          医師ナンバー: Yup.number()
            .typeError(
              i18n.t('validation.doctorConsultationTimePage.typeNumber')
            )
            .required(
              i18n.t('validation.doctorConsultationTimePage.requiredDoctorNo')
            ),
          年: Yup.number()
            .typeError(
              i18n.t('validation.doctorConsultationTimePage.typeNumber')
            )
            .required(
              i18n.t('validation.doctorConsultationTimePage.requiredYear')
            ),
          月: Yup.number()
            .typeError(
              i18n.t('validation.doctorConsultationTimePage.typeNumber')
            )
            .required(
              i18n.t('validation.doctorConsultationTimePage.requiredMonth')
            ),
          平均診療時間: Yup.number()
            .typeError(
              i18n.t('validation.doctorConsultationTimePage.typeNumber')
            )
            .required(
              i18n.t('validation.doctorConsultationTimePage.requiredScore')
            ),
        })
      ),
  })

  const exceptKeys = ['checked', 'errorMessage']

  return (
    <Formik
      initialValues={{
        data: [],
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      render={formikProps => {
        const {
          values,
          errors,
          setFieldValue,
          handleSubmit,
          touched,
        } = formikProps
        const { data } = values
        let keys = []
        if (data.length > 0) {
          keys = Object.keys(data[0]).filter(
            key => key !== 'errorMessage' || key !== 'checked'
          )
        }

        return (
          <React.Fragment>
            <div className='staff-header'>
              <div className='staff-title'>
                {'医師平均診療時間CSVアップロード'}
                <BreadCrumb
                  items={[
                    {
                      to: Router.get(Router.staffDoctorConsultation, {}),
                      title: '医師平均診療時間',
                    },
                    {
                      title: '医師平均診療時間CSVアップロード',
                    },
                  ]}
                />
              </div>
              <div className='staff-buttons'>
                <Button
                  icon='pi pi-download'
                  className='p-button-normal'
                  onClick={downloadSample}
                  label={i18n.t('main.sampleCsv')}
                />
              </div>
            </div>
            {isUploadPermitted || isUploadCheckPermitted ? (
              <div className='container'>
                <div className='box'>
                  <div className='box-top'>
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                      }}
                    >
                      <div className='alert is-left'>
                        {typeof errors.data === 'string' &&
                          touched.data &&
                          errors.data}
                      </div>
                    </div>
                    {values.data.length > 0 && (
                      <Button
                        onClick={() => setFieldValue('data', [])}
                        label={i18n.t('main.cancel')}
                        className='p-button-secondary'
                        icon='pi pi-times'
                        style={{ marginRight: '20px' }}
                      />
                    )}
                    {isUploadCheckPermitted ? (
                      <Button
                        onClick={() => {
                          if (
                            (errors.data && errors.data.length > 0) ||
                            values.data.find(d => d.errorMessage)
                          ) {
                            popup.error(i18n.t('main.hasCsvFileError'))
                          } else {
                            checkCsvData(values, { setFieldValue })
                          }
                        }}
                        label={i18n.t('staff.csvUpload.check')}
                        type='submit'
                        disabled={data.length === 0 || isUploaded}
                        style={{ marginRight: '20px' }}
                      />
                    ) : null}
                    {isUploadPermitted ? (
                      <Button
                        onClick={() => {
                          if (
                            (errors.data && errors.data.length > 0) ||
                            values.data.find(d => d.errorMessage)
                          ) {
                            popup.error(i18n.t('main.hasCsvFileError'))
                          } else {
                            handleSubmit()
                          }
                        }}
                        label={i18n.t('staff.csvUpload.submit')}
                        type='submit'
                        disabled={data.length === 0 || isUploaded}
                      />
                    ) : null}
                  </div>
                  {values.data.length < 1 && (
                    <Dropzone
                      onDrop={files => {
                        if (files.length > 0) {
                          Papa.parse(files[0], {
                            header: true,
                            complete: async results => {
                              setFieldValue('data', results.data)
                            },
                          })
                        }
                      }}
                      accept='.csv'
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ className: 'dropzone' })}>
                          <input {...getInputProps()} />
                          <p>{i18n.t('doctor.uploadFile.dropFileHere')}</p>
                        </div>
                      )}
                    </Dropzone>
                  )}
                  {data.length > 0 && (
                    <div className='overflow-container'>
                      <table className='table'>
                        <thead>
                          <tr>
                            <th>{i18n.t('main.action')}</th>
                            {keys.map(
                              (key, index) =>
                                !exceptKeys.includes(key) && (
                                  <th key={`${key}_${index}`}>
                                    {translateKeys[key]}
                                  </th>
                                )
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          <FieldArray
                            name='data'
                            render={({ remove }) => (
                              <React.Fragment>
                                {data.map((item, i) => {
                                  const error =
                                    errors.data && errors.data.length > 0
                                      ? errors.data[i]
                                      : false

                                  const isChecked = data[i].checked
                                  const errorMessage =
                                    item.errorMessage ||
                                    Object.keys(error || {}).reduce(
                                      (acc, curr) => {
                                        return `${acc}\n${error[curr]}`
                                      },
                                      ''
                                    )

                                  return (
                                    <React.Fragment>
                                      <tr key={`${i}`}>
                                        {!errorMessage ? (
                                          <td>
                                            {isChecked ? (
                                              <Button
                                                icon='pi pi-check'
                                                className='p-button-success'
                                                tooltip={'OK'}
                                              />
                                            ) : (
                                              <Button
                                                icon='pi pi-info'
                                                tooltip={i18n.t(
                                                  'staff.csvUpload.notChecked'
                                                )}
                                              />
                                            )}
                                          </td>
                                        ) : (
                                          <td>
                                            <div>
                                              <Button
                                                onClick={() => remove(i)}
                                                icon='pi pi-times'
                                                className='p-button-danger'
                                              />
                                            </div>
                                          </td>
                                        )}
                                        {keys.map(
                                          key =>
                                            !exceptKeys.includes(key) && (
                                              <td>{item[key]}</td>
                                            )
                                        )}
                                      </tr>
                                      {errorMessage && (
                                        <tr key={`errorMessage_${i}`}>
                                          <td colSpan={keys.length + 1}>
                                            <div className='alert is-left'>
                                              {errorMessage}
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </React.Fragment>
                                  )
                                })}
                              </React.Fragment>
                            )}
                          />
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </React.Fragment>
        )
      }}
    />
  )
}

export default DocTorConsultationCsvScene
